"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["sm"] = 576] = "sm";
    Breakpoints[Breakpoints["md"] = 768] = "md";
    Breakpoints[Breakpoints["lg"] = 992] = "lg";
    Breakpoints[Breakpoints["xl"] = 1200] = "xl";
})(Breakpoints = exports.Breakpoints || (exports.Breakpoints = {}));
exports.media = Object.keys(Breakpoints).reduce(function (acc, label) {
    acc[label] = function (literals) {
        var placeholders = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            placeholders[_i - 1] = arguments[_i];
        }
        return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      @media (min-width: ", "em) {\n        ", "\n      }\n    "], ["\n      @media (min-width: ", "em) {\n        ", "\n      }\n    "])), Breakpoints[label] / 16, styled_components_1.css.apply(void 0, __spreadArrays([literals], placeholders))).join("");
    };
    return acc;
}, {});
exports.breakpoints = Breakpoints;
exports.default = exports.breakpoints;
var templateObject_1;
//# sourceMappingURL=breakpoints.js.map